import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

/** Shared reason-prompt dialog for the actions that land in the admin audit:
 *  re-sync (single tour / listing) and reconcile. */
export const ReasonDialog: React.FC<{
  open: boolean;
  title: string;
  description: string;
  busy: boolean;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
  /** Extra controls rendered under the reason field (e.g. "Full rescan"). */
  children?: React.ReactNode;
}> = ({ open, title, description, busy, confirmLabel = 'Confirm', onCancel, onConfirm, children }) => {
  const [reason, setReason] = React.useState('');

  React.useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <label className="block space-y-1.5">
          <span className="text-sm font-medium">Reason</span>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={2}
            placeholder="Why you are doing this, for the audit trail"
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </label>
        {children}
        <AlertDialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button disabled={busy || !reason.trim()} onClick={() => onConfirm(reason.trim())}>
            {busy ? 'Working…' : confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ReasonDialog;
